import { useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ToolsContext } from '../contexts';
import { useAsgActions } from '../../../shared/src/hooks/use-asg-actions.hook';

export const useRecommendations = (
    {
        vertical = null,
    } = {},
) => {
    const Tools = useContext(ToolsContext);
    const {
        casinoId,
        countryCode,
        regulation,
        platformId,
        platformReady,
    } = useSelector((state) => state.app);
    const {
        session,
        isLoggedIn,
    } = useSelector((state) => state.player);
    const encryptedUserID = session ? session.EncryptedUserID : null;

    const { async: { getRecommendedGames } } = useAsgActions();
    const dispatch = useDispatch();

    useEffect(() => {
        if (platformReady
            && isLoggedIn
        ) {
            const requestParams = {
                userId: encryptedUserID,
                casinoId,
                country: countryCode,
                regulation,
                platformId,
            };

            // fetch recommendations from Exponea
            dispatch(getRecommendedGames({
                requestParams,
                categoriesOrder: vertical?.categoriesOrder,
                globals: { Tools }
            }));
        }
    }, [
        platformReady,
        encryptedUserID,
        countryCode,
        casinoId,
        regulation,
        platformId,
        isLoggedIn,
    ]);

    return useSelector((state) => state.recommendations);
};
